import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Link,
} from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  CircularProgress,
  Grid,
  Typography,
  Button,
  Paper,
  Divider,
} from '@material-ui/core';

import Alert from '../../common/components/Alert';
import MainLayout from '../../common/components/MainLayout';

import * as mainActions from '../actions';
import classes from '../../css/getCSS';
import * as routes from '../../config/routes';


class NewsDetail extends Component {
  componentDidMount() {
    document.title = 'Loading news...';
    window.scrollTo(0, 0);
    this.props.getNewsItem(this.props.match.params.slug);
  }

  componentWillUnmount() {
    this.props.deepUnmount();
  }

  render() {
    if (this.props.currentNews) {
      document.title = this.props.currentNews.title;
    }

    let loading = null;

    if (this.props.loading) {
      loading = (
        <div align="center" style={{ marginTop: '50px' }}>
          <CircularProgress align="center" size={50} /> <br />
          <Typography variant="body1">Loading. Please wait</Typography>
        </div>
      );
    }

    let errorAlert = null;
    if (this.props.error) {
      errorAlert = <Alert type="danger">{this.props.error}</Alert>;
    }

    let content = null;
    if (this.props.currentNews) {
      const news = this.props.currentNews;
      const text = <div dangerouslySetInnerHTML={{ __html: news.content }} />  // eslint-disable-line

      let registerBtn = null;
      if (news.custom_link && news.custom_button_text) {
        registerBtn = (
          <a href={news.custom_link} className={classes.linkDeCSS}>
            <Button variant="contained" color="primary" size="large" className={classes.button}>
              {news.custom_button_text}
            </Button>
          </a>
        );
      }

      content = (
        <Paper className={[classes.card, classes.cardFancy].join(' ')}>
          <Typography variant="headline">{news.title}</Typography>
          <span className={classes.titleUnderline} />
          <br />
          <Divider />
          <div style={{ fontFamily: 'Source Sans Pro' }}>{text}</div>
          {registerBtn}
        </Paper>
      );
    }

    let rootClass = null;
    if (this.props.token) {
      rootClass = classes.dashboardLayout;
    }

    return (
      <MainLayout rootClass={rootClass} isAuthenticated={this.props.token !== null}>
        <Grid container style={{ justifyContent: 'center' }}>
          <Grid item md={6} sm={8} xs={12}>
            <br />
            <Link className={classes.linkDeCSS} to={formatRoute(routes.NEWS)}>
              <Button variant="contained" color="default">Back to all news</Button>
            </Link>
            <br /><br />
            {loading}
            {errorAlert}
            {content}
          </Grid>
        </Grid>
      </MainLayout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    token: state.auth.token,
    loading: state.main.loading,
    error: state.main.error,
    currentNews: state.main.currentNews,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(mainActions.onUnmount()),
    deepUnmount: () => dispatch(mainActions.deepUnmount()),
    getNewsItem: slug => dispatch(mainActions.getNewsItem(slug)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewsDetail));



// WEBPACK FOOTER //
// ./src/main/containers/NewsDetail.js